import { useDocumentPreviewService } from '..';
import { useState, useCallback, useEffect } from 'react';
import { normalizeStoragePath } from '../documentStorageService';
import { useDocumentStorageContext } from 'framework/documentStorage';

const useDocumentBlob = (documentPath: string | null) => {
  const { getDocumentPreviewBlob } = useDocumentPreviewService();
  const { getDocumentToken } = useDocumentStorageContext();
  const [loading, setLoading] = useState(true);
  const [hasError, setError] = useState<Nullable<boolean>>(null);
  const [blobUrl, setBlobUrl] = useState<string | null>(null);

  const revokeBlobUrl = () => {
    if (blobUrl) {
      URL.revokeObjectURL(blobUrl);
    }
  };

  const loadBlob = useCallback(
    async (path: string) => {
      try {
        setLoading(true);
        revokeBlobUrl();
        const preSignedUrl = await getDocumentToken(normalizeStoragePath(path));
        const blobDocument = await getDocumentPreviewBlob(preSignedUrl);
        const url = URL.createObjectURL(blobDocument);
        setBlobUrl(url);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getDocumentToken, getDocumentPreviewBlob],
  );

  useEffect(() => {
    if (documentPath) {
      loadBlob(documentPath);
    } else {
      setLoading(false);
      setError(null);
      setBlobUrl(null);
    }
    return revokeBlobUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentPath]);

  return { blobUrl, loading, hasError, loadBlob };
};

export default useDocumentBlob;
